"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WindNorthwestModerate = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const WindNorthwestModerate = ({ style: styleOverrides = {}, size, className = "", }) => {
    const cssStyle = size !== null && size !== void 0 ? size : "100%";
    const coreStyle = {
        display: "inlineBlock",
        width: cssStyle,
        height: cssStyle,
    };
    const style = Object.assign(Object.assign({}, coreStyle), styleOverrides);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ id: "wind-northwest-moderate", viewBox: "0 0 32 32", className: `${className}`, style: style }, { children: (0, jsx_runtime_1.jsxs)("g", Object.assign({ id: "wind-northwest-moderate", fill: "none", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, { children: [(0, jsx_runtime_1.jsx)("path", { d: "m24.381 13.695-.222 9.953-10.02.223.05-2.288 7.733-.171.17-7.667 2.29-.05Z", fill: "#1D4B87", fillRule: "evenodd" }), (0, jsx_runtime_1.jsx)("path", { d: "m19.002 8.704-.223 9.953-10.02.223.05-2.288 7.734-.172.17-7.666 2.289-.05Z", fill: "#909AB5", fillRule: "evenodd" })] })) })));
};
exports.WindNorthwestModerate = WindNorthwestModerate;
